<template>
<div class="chapter">
<div class="inner_page">
<div class="copyclr">
<p class="copy2">Publisher: Amy Barrett-Daffin</p>
<p class="copy1">Creative Director: Gailen Runge</p>
<p class="copy1">Acquisitions Editor: Roxane Cerda</p>
<p class="copy1">Managing Editor: Liz Aneloski</p>
<p class="copy1">Editor: Kathryn Patterson</p>
<p class="copy1">Technical Editor: Debbie Rodgers</p>
<p class="copy1">Cover/Book Designer: April Mostek</p>
<p class="copy1">Production Coordinator: Tim Manibusan</p>
<p class="copy1">Production Editor: Alice Mace Nakanishi</p>
<p class="copy1">Illustrator: Linda Johnson</p>
<p class="copy1">Photo Assistant: Rachel Holmes</p>
<p class="copy1">Subjects photography by Rachel Holmes and Diane Pedersen and instructional photography by Kelly Burgoyne and Estefany Gonzalez of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="copy2">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_copy.vue?a0bce58e